import { useCallback, useEffect, useRef } from 'react';

type UseTimeoutReturn = () => void;

const useTimeout = <T extends () => void>(callback: T, timeoutMs: number | null): UseTimeoutReturn => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const callbackRef = useRef(callback);

  // Update callback ref on each render
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const clearTimeoutFn = useCallback(() => {
    if (!timeoutRef.current) {
      return;
    }

    clearTimeout(timeoutRef.current);

    timeoutRef.current = null;
  }, []);

  useEffect(() => {
    if (timeoutMs === null) {
      return;
    }

    timeoutRef.current = setTimeout(() => callbackRef.current(), timeoutMs);

    return clearTimeoutFn;
  }, [timeoutMs, clearTimeoutFn]);

  return clearTimeoutFn;
};

export { useTimeout };
